jQuery(document).ready(function($) {
    "use strict";

    // DOM-hooks
    $('.cyklos_scroll_to_hook').on('click', onClick);

    if(document.location.hash.indexOf('cta')) {
        $('html').css({ scrollTop: 0 });
        doScrollTo(document.location.hash, false);
    }

    // Functionality
    function onClick(e) {
        e.preventDefault();
        doScrollTo($(this).attr('href'));
    }

    function doScrollTo(id, doSetHash) {
        if(doSetHash == null)
            doSetHash = true;

        var $target = $(id);

        if($target.length === 0)
            return;

        setHash(id.replace('#', ''));
        var offset = $target.offset();

        $('html,body').animate({
            scrollTop: offset.top - 170
        },1000);

        flashElementBackground($target);
    }

    function flashElementBackground($element) {

    }

    function setHash(hash) {
        if(history && history.pushState) {
            history.pushState(null, null, '#' + hash);
        } else {
            document.location.hash = hash;
        }
    }
});